module.exports = __webpack_public_path__ + "static/media/eclassLogo.6cb234dc.svg";